import React from "react";

/**
 * Heraldic HN crest — wheat sheaves above a shield with monogram "HN".
 * Color is controlled via currentColor.
 */
export const Crest = ({ size = 56, className = "", strokeWidth = 1.2 }) => (
  <svg
    viewBox="0 0 120 140"
    width={size}
    height={(size * 140) / 120}
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* Wheat sheaf top */}
    <path d="M60 4 V22" />
    <path d="M52 12 Q60 18 60 22" />
    <path d="M68 12 Q60 18 60 22" />
    <path d="M46 18 Q60 24 60 26" />
    <path d="M74 18 Q60 24 60 26" />
    {/* Crown / coronet */}
    <path d="M40 28 L48 22 L56 28 L60 22 L64 28 L72 22 L80 28 V32 H40 Z" />
    {/* Shield */}
    <path d="M30 36 H90 V70 Q90 96 60 116 Q30 96 30 70 Z" />
    {/* Inner shield rule */}
    <path d="M36 42 H84 V70 Q84 90 60 108 Q36 90 36 70 Z" opacity="0.5" />
    {/* Monogram H */}
    <path d="M48 60 V86 M48 73 H58 M58 60 V86" />
    {/* Monogram N */}
    <path d="M64 86 V60 L74 86 V60" />
    {/* Banner / ribbon below */}
    <path d="M28 122 L60 132 L92 122 L86 128 L60 138 L34 128 Z" opacity="0.85" />
  </svg>
);

export default Crest;
